'use client';

import React from 'react';
import { useTranslation } from 'react-i18next';

import { Spin } from 'components';
import EditButton from './components/EditButton';

import useWindowResponsiveness from 'hooks/common/useWindowResponsiveness';

import { IEditableBlockValueProps } from './EditableBlockValue.types';

import './EditableBlockValue.styles.scss';

const EditableBlockValue = ({
  value,
  loading,
  disabled,
  rightActionsComponent,
  leftActionsComponent,
  wordBreak,
  ellipsis,
  wrapActions,
  actionsAlignEnd,
  onEditButtonClick,
}: IEditableBlockValueProps) => {
  const { t } = useTranslation();
  const { isMobileView } = useWindowResponsiveness(700);

  const fontSize = isMobileView ? 14 : 16;

  const ellipsisClass = ellipsis ? 'np-editable-block-value__actions-label--ellipsis' : '';
  const actionsAlignClass = actionsAlignEnd ? 'np-editable-block-value__actions--end' : '';

  return (
    <>
      {loading ? (
        <Spin size="small" />
      ) : (
        <div className={`np-editable-block-value__actions-label ${ellipsisClass}`}>
          {typeof value === 'string' ? (
            <span style={{ wordBreak, fontSize }}>{value || t('common.notSet')}</span>
          ) : (
            value
          )}
        </div>
      )}

      <div
        className={`np-editable-block-value__actions ${actionsAlignClass}`}
        style={{ flexWrap: wrapActions ? 'wrap' : 'nowrap' }}
      >
        {leftActionsComponent}

        {<EditButton onClick={onEditButtonClick} disabled={disabled} />}

        {rightActionsComponent}
      </div>
    </>
  );
};

export default EditableBlockValue;
